module.exports = __webpack_public_path__ + "fonts/Simply Rounded Bold Italic.fcf0f04f.ttf";